/**
 * nav.js — tiny history-based navigation for pages that have their own URL
 * (Upload Invoices at /accounts/invoices/…, VAT at /accounts/vat).
 * The app is still a single bundle; this keeps deep links, the browser back
 * button and bookmarks working without pulling in a router.
 */
import { useEffect, useState } from 'react';

export function navigate(path, { replace = false } = {}) {
  if (replace) window.history.replaceState({}, '', path); else window.history.pushState({}, '', path);
  window.dispatchEvent(new PopStateEvent('popstate'));
}

export function usePath() {
  const [path, setPath] = useState(window.location.pathname + window.location.search);
  useEffect(() => {
    const h = () => setPath(window.location.pathname + window.location.search);
    window.addEventListener('popstate', h);
    return () => window.removeEventListener('popstate', h);
  }, []);
  return path;
}

/** Which Dashboard page a path belongs to (null = the main grid). */
export function pageForPath(pathname) {
  if (pathname.startsWith('/accounts/invoices')) return 'invoiceIntake';
  if (pathname.startsWith('/accounts/vat')) return 'vat';
  return null;
}
